module.exports = __webpack_public_path__ + "static/media/dop-twin.3b73d72d.svg";